import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef, useState } from 'react';
import { isEmptyData } from '../../../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { setProducts } from '../../../../store/reducers/product';
import useNearBottom from '../../../../hook/useNearBottom';

const Search = () => {
	const { scrollToTop } = useNearBottom();

	const [isExpanded, setIsExpanded] = useState(false);
	const [query, setQuery] = useState('');
	const divRef = useRef(null);
	const inputRef = useRef(null);
	const timeoutRef = useRef(null);

	// handle click outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!divRef.current) return;

			if (!divRef.current.contains(event.target)) {
				if (isEmptyData(query)) {
					setIsExpanded(false);
				}
			}
		};

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [query]);

	// autofocus ketika expand
	useEffect(() => {
		if (isExpanded && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isExpanded]);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	return (
		<>
			<div ref={divRef} onClick={() => scrollToTop()} className={`flex items-center transition-all duration-300 bg-white justify-center pl-2`}>
				<MagnifyingGlassIcon className={`h-5 w-5 text-gray-900`} strokeWidth={3} />
			</div>
		</>
	);
};

export default Search;
